// Rest-timer card for the calendar sidebar "phone" preview (type 'RT').
// Copy of the workouts module's TimerCard/RestTimer visual: the countdown circle showing the
// rest duration plus restart/play buttons. Static (not playing); interaction blocked by overlay.
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { BoxShadow } from '../../../../shared/GlobalStyles';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: ${BoxShadow};
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.surface};
  padding-top: 20px;
  margin-top: 20px;
`;

const ContentContainer = styled('div')`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
`;

const TimerDiv = styled('div')`
  font-family: 'Nunito Sans';
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
`;

const TimerValue = styled('div')`
  font-size: 40px;
`;

const ButtonContainer = styled('div')`
  display: flex;
  width: 80%;
`;

const Button = styled('button')`
  display: flex;
  width: 80%;
  height: 75px;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  cursor: pointer;
`;

const renderTime = ({ remainingTime }) => {
  if (remainingTime === 0) {
    return <TimerDiv>Done!</TimerDiv>;
  }
  return (
    <TimerDiv>
      <TimerValue>{remainingTime}</TimerValue>
    </TimerDiv>
  );
};

const CalendarTimerCard = ({ workoutObject }) => (
  <Container>
    <ContentContainer>
      <CountdownCircleTimer
        isPlaying={false}
        size={120}
        duration={workoutObject.timerDurationInSeconds || 0}
        strokeWidth={6}
        colors={['#004777', '#F7B801', '#A30000', '#A30000']}
        colorsTime={[10, 6, 3, 0]}
      >
        {renderTime}
      </CountdownCircleTimer>
    </ContentContainer>
    <ButtonContainer>
      <Button type='button'>
        <IcomoonReact iconSet={iconSet} size={35} icon='restart' color='black' />
      </Button>
      <Button type='button'>
        <IcomoonReact iconSet={iconSet} size={35} icon='play' color='black' />
      </Button>
    </ButtonContainer>
  </Container>
);

CalendarTimerCard.propTypes = {
  workoutObject: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarTimerCard;
